var _line, _path, _line2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncognitoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14.25,
    x2: 22,
    y2: 14.25,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14L8.5 4.00001L11.334 6.53034C11.7134 6.86909 12.2866 6.86909 12.666 6.53034L15.5 4L19 14",
    stroke: "#1A1B1D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16.7,
    x2: 20,
    y2: 16.7,
    stroke: "#1A1B1D",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 17.2C4.6 16.9791 4.77909 16.8 5 16.8H10.5894C10.865 16.8 11.0581 17.0723 10.9668 17.3324L10.5699 18.4635C10.3731 19.0245 9.8434 19.4 9.24888 19.4H6C5.2268 19.4 4.6 18.7732 4.6 18V17.2Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0332 17.3324C12.9419 17.0723 13.135 16.8 13.4106 16.8H19C19.2209 16.8 19.4 16.9791 19.4 17.2V18C19.4 18.7732 18.7732 19.4 18 19.4H14.7511C14.1566 19.4 13.6269 19.0245 13.4301 18.4635L13.0332 17.3324Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognitoIcon);
export default __webpack_public_path__ + "static/media/incognito-icon.a9238aa26de9fec76e3b153b69db6f2d.svg";
export { ForwardRef as ReactComponent };